var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import styled, { css } from 'styled-components';
import MuiTypography from '@mui/material/Typography';
export var StyledTypography = styled(MuiTypography)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose([""])));
export var StyledText = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var italic = _ref.italic,
    weight = _ref.weight,
    transform = _ref.transform;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    font-weight: ", ";\n    text-transform: ", ";\n    ", "\n  "])), weight, transform, italic && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      font-style: italic;\n    "]))));
});